import type { ConfigType } from '@plone/registry';
import StickyHeaderController from '../components/Slots/StickyHeaderController';

export default function install(config: ConfigType) {
  config.registerSlotComponent({
    name: 'stickyHeaderController',
    slot: 'aboveHeader',
    component: StickyHeaderController,
  });

  return config;
}
